/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import { AgentVerified } from 'components/lib/DesignSystem/Icons'
import Tooltip from 'components/lib/DesignSystem/V3/Tooltip'

import {
  BottomDetailDivider,
  EmptyAudienceContainer,
  EmptyAudienceHint,
  EmptyAudienceIconBadge,
  EmptyAudienceLabel,
  EmptyAudienceLabelGroup,
  EmptyAudienceTooltipContent,
  EmptyAudienceTooltipHint,
  EmptyAudienceTooltipTitle,
} from '../styles'

const EmptyAudienceNote = ({ campaignId }) => (
  <EmptyAudienceContainer
    id={`Psima_Dashboard_EmptyAudience_div-${campaignId}`}
    data-testid={`Psima_Dashboard_EmptyAudience_div-${campaignId}`}
  >
    <EmptyAudienceLabelGroup>
      <Tooltip
        id={`Psima_Dashboard_EmptyAudience_tooltip-${campaignId}`}
        side="top"
        arrow
        content={
          <EmptyAudienceTooltipContent>
            <EmptyAudienceTooltipTitle>All employees assigned elsewhere</EmptyAudienceTooltipTitle>
            <EmptyAudienceTooltipHint>
              Select this card to move these employees back here instead
            </EmptyAudienceTooltipHint>
          </EmptyAudienceTooltipContent>
        }
      >
        <EmptyAudienceIconBadge>
          <AgentVerified noDefaultFill width="16px" height="16px" fill="var(--color-text)" />
        </EmptyAudienceIconBadge>
      </Tooltip>
      <EmptyAudienceLabel data-testid={`Psima_Dashboard_EmptyAudienceLabel_span-${campaignId}`}>
        All employees assigned elsewhere
      </EmptyAudienceLabel>
    </EmptyAudienceLabelGroup>
    <BottomDetailDivider />
    <EmptyAudienceHint data-testid={`Psima_Dashboard_EmptyAudienceHint_span-${campaignId}`}>
      Select this card to move these employees back here instead
    </EmptyAudienceHint>
  </EmptyAudienceContainer>
)

export default EmptyAudienceNote
